import { z } from 'zod';

export const BotChannelTypeSchema = z.union([
  z.literal('msteams'),
  z.literal('m365extensions'),
]);
export const BotFrameworkBotSchema = z.object({
  name: z.string().min(1).max(30),
  botId: z.string().min(1),
  messagingEndpoint: z.string(), //For some unknown reason this is allowed to be empty (but not undefined)... just delightful.
  callingEndpoint: z.nullable(z.string()), // Oddly this is _nullable_ not optional due to server response. I'm tempted to fix this using transformers.
  canAccessBotFramework: z.optional(z.boolean()),
  iconUrl: z.string().url(),
  description: z.string(), // This appears to be unused.
  configuredChannels: z.array(BotChannelTypeSchema),
});

export type BotChannelType = z.infer<typeof BotChannelTypeSchema>;
export type BotFrameworkBot = z.infer<typeof BotFrameworkBotSchema>;

export const EmptyBotFrameworkBot: BotFrameworkBot = {
  name: '',
  botId: '',
  messagingEndpoint: '',
  callingEndpoint: null,
  iconUrl: '',
  description: '',
  configuredChannels: []
}
